import {
	APP_INITIALIZER,
	enableProdMode,
	importProvidersFrom,
	SecurityContext
} from '@angular/core';
import 'hammerjs';
import { WebpackTranslateLoader } from './app/app.module';
import { environment } from './environments/environment';
import 'echarts/theme/macarons.js';
import { LicenseManager } from 'ag-grid-enterprise';
import {
	ANA_AUTOMATION_RECOMMENDATIONS_RENDERER,
	ANA_CARD_RENDERERS,
	ANA_OUTREACH_REVIEW_RENDERER,
	AnaAutomationRecommendationsCardComponent,
	BaseApiUrl,
	DialogService
} from 'components';
import { MOCK_PROVIDERS } from './app/providers/mock-providers';
import { ANA_OPEN_PROFILE_PRICE_PROVIDER } from './app/billing/ana-open-profile-price.provider';
import { AnaOutreachReviewRendererComponent } from './components/ana-outreach-review/ana-outreach-review-renderer.component';
import {
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatDialogModule
} from '@angular/material/dialog';
import { AppCustomPreloader } from './app/app-routing-preloader';
import { AuthenticationService } from './app/_services/authentication.service';
import { UserServiceApi } from './app/_services/user/user.api.service';
import { SidenavService } from './app/_services/side-nav.service';
import { InterceptorsProvider } from './app/_services/interceptors/intercepors.provider';
import { UserStatesService } from '@brand-lolly/app/services/user-states.service';
import { provideLottieOptions } from 'ngx-lottie';
import {
	provideHttpClient,
	withInterceptorsFromDi,
	HttpClient
} from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { Observable, from } from 'rxjs';
import { AgGridModule } from 'ag-grid-angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { ColorPickerDirective } from 'ngx-color-picker';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './app/shared/shared.module';
import { SidenavModule } from './app/sidenav/sidenav.module';
import { NgxEchartsModule } from 'ngx-echarts';
import { MaterialModule } from './app/material.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { HammerModule } from '../node_modules/@angular/platform-browser';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { MarkdownModule } from 'ngx-markdown';
import player from 'lottie-web';
import { AppComponent } from './app/app.component';
import { ClarityFunnelService } from './app/shared/services/clarity-funnel.service';

LicenseManager.setLicenseKey(
	'CompanyName=ABSTRACT HOLDINGS LIMITED,LicensedApplication=Filed.com,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-017120,ExpiryDate=20_August_2022_[v2]_MTY2MDk1MDAwMDAwMA==e4cc84f0a38826f6ad8925417539bf41'
);

BaseApiUrl.replace(environment);

if (environment.Flags.production) {
	enableProdMode();
}

bootstrapApplication(AppComponent, {
	providers: [
		importProvidersFrom(
			TranslateModule.forRoot({
				loader: {
					provide: TranslateLoader,
					useClass: WebpackTranslateLoader
				}
			}),
			AgGridModule,
			ColorPickerDirective,
			AppRoutingModule,
			ReactiveFormsModule,
			SharedModule,
			SidenavModule,
			NgxEchartsModule.forRoot({
				echarts: () => import('echarts')
			}),
			MaterialModule,
			MatDialogModule,
			NgxSkeletonLoaderModule.forRoot({
				animation: 'pulse',
				loadingText: 'This item is actually loading...'
			}),
			HammerModule,
			NgxDaterangepickerMd.forRoot(),
			MarkdownModule.forRoot({
				loader: HttpClient,
				// Make the security contract explicit: Ana's assistant text is
				// attacker-influenceable (prompt injection), so markdown must
				// always sanitize to inert HTML. Never relax to
				// SecurityContext.NONE for chat surfaces.
				sanitize: SecurityContext.HTML
			})
		),
		...MOCK_PROVIDERS,
		{
			provide: MatDialogRef,
			useValue: {}
		},
		{ provide: MAT_DIALOG_DATA, useValue: {} },
		AppCustomPreloader,
		AuthenticationService,
		UserServiceApi,
		SidenavService,
		InterceptorsProvider,
		UserStatesService,
		DialogService,
		// The brand app's custom Ana card renderers, by renderer name. A custom
		// card whose renderer is missing here draws its standard fallback.
		{
			provide: ANA_CARD_RENDERERS,
			useValue: {
				// The retired starting-point chooser: its rows are a live control
				// the facade settles, which a standard list cannot be.
				[ANA_AUTOMATION_RECOMMENDATIONS_RENDERER]:
					AnaAutomationRecommendationsCardComponent,
				// The outreach review reads the campaign's review live and acts on
				// it, which needs the brand app's HTTP service.
				[ANA_OUTREACH_REVIEW_RENDERER]:
					AnaOutreachReviewRendererComponent
			}
		},
		// What opening a creator's profile from an Ana card costs, from the brand
		// app's price list, which the library cannot read itself.
		ANA_OPEN_PROFILE_PRICE_PROVIDER,
		provideLottieOptions({
			player: () => {
				return player;
			}
		}),
		provideHttpClient(withInterceptorsFromDi()),
		provideAnimations(),
		{
			// Load Microsoft Clarity only for the Social Listening funnel
			// (onboarding + first steps of project creation). The service
			// watches navigation and injects the tag on first funnel entry.
			provide: APP_INITIALIZER,
			multi: true,
			useFactory: (clarityFunnel: ClarityFunnelService) => () =>
				clarityFunnel.init(),
			deps: [ClarityFunnelService]
		}
	]
}).catch(err => console.log(err));
